/** Canonical document type codes + “Other” for custom-named uploads (admin onboarding, employee docs). */

export const DOCUMENT_TYPE_OTHER = 'other';
export const DOCUMENT_TYPE_ONBOARDING_FORM = 'onboarding_form';

export const DOCUMENT_TYPE_OPTIONS = [
  { value: DOCUMENT_TYPE_ONBOARDING_FORM, label: 'Completed Onboarding Form' },
  { value: 'aadhaar', label: 'Aadhaar Card' },
  { value: 'aadhaar_front', label: 'Aadhaar Card - Front' },
  { value: 'aadhaar_back', label: 'Aadhaar Card - Back' },
  { value: 'pan', label: 'PAN Card' },
  { value: 'photo', label: 'Photo / Passport' },
  { value: 'degree', label: 'Degree / Diploma' },
  { value: 'offer_letter', label: 'Offer Letter' },
  { value: 'relieving_letter', label: 'Relieving Letter' },
  { value: 'relieving_email', label: 'Relieving Email' },
  { value: 'experience_letter', label: 'Experience Letter' },
  { value: 'payslip_3months', label: '3 Months Payslip' },
  { value: 'bank_proof', label: 'Bank Statement / Cancelled Cheque / Passbook' },
  { value: 'address_proof', label: 'Address Proof' },
  { value: DOCUMENT_TYPE_OTHER, label: 'Other (enter document name)' },
];

/**
 * Documents a candidate uploads during self-service onboarding.
 * `appliesTo: 'all'` is required of everyone; 'experienced' only of experienced hires.
 * Mirrors hrms-backend/constants/onboardingDocuments.js.
 */
export const ONBOARDING_DOCUMENTS = [
  { value: 'address_proof', label: 'Residence Proof', appliesTo: 'all' },
  { value: 'aadhaar_front', label: 'Aadhaar Card - Front', appliesTo: 'all' },
  { value: 'aadhaar_back', label: 'Aadhaar Card - Back', appliesTo: 'all' },
  { value: 'pan', label: 'PAN Card', appliesTo: 'all' },
  { value: 'bank_proof', label: 'Bank Statement / Cancelled Cheque / Passbook Front Page', appliesTo: 'all' },
  { value: 'photo', label: 'Passport Size Photo', appliesTo: 'all' },
  { value: 'offer_letter', label: 'Offer Letter / Appointment Letter', appliesTo: 'experienced' },
  { value: 'payslip_3months', label: '3 Months Payslip', appliesTo: 'experienced' },
  { value: 'relieving_email', label: 'Relieving Email', appliesTo: 'experienced' },
  { value: 'relieving_letter', label: 'Screenshot of Resignation Email / Relieving Letter', appliesTo: 'experienced' },
];

/** @param {'fresher'|'experienced'} employmentType */
export function onboardingDocumentsFor(employmentType) {
  return ONBOARDING_DOCUMENTS.filter(
    (doc) => doc.appliesTo === 'all' || doc.appliesTo === employmentType
  );
}

export const DOCUMENT_LABEL_MIN_LENGTH = 2;
export const DOCUMENT_LABEL_MAX_LENGTH = 120;

/**
 * Title shown in lists: custom label for type "other", else mapped label or raw type.
 */
export function documentDisplayName(doc, options = DOCUMENT_TYPE_OPTIONS) {
  const custom = doc?.documentLabel?.trim?.();
  if (custom) return custom;
  const mapped = options.find((d) => d.value === doc.documentType)?.label;
  if (mapped) return mapped;
  return doc?.documentType || 'Document';
}
